import { FormField, FormLabel } from "@impero-com/ui";
import { Input } from "antd";

interface CommentFieldProps {
    value: string;
    onChange: (value: string) => void;
    label: string;
    placeholder?: string;
    /** When set, the field is shown in an error state with this message. */
    error?: string;
    rows?: number;
}

export function CommentField({
    value,
    onChange,
    label,
    placeholder,
    error,
    rows = 5,
}: CommentFieldProps) {
    return (
        <FormField error={error}>
            <FormLabel>{label}</FormLabel>
            <Input.TextArea
                value={value}
                onChange={(event) => onChange(event.target.value)}
                placeholder={placeholder}
                rows={rows}
                status={error ? "error" : undefined}
            />
        </FormField>
    );
}
